module platform {

   declare const h5: any;

   class ImageDirective implements ng.IDirective {

      link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
         scope.$watch('ngSrc', () => {
            if (attrs.ngSrc) {
               var fixedUrl = this.fixUrl(attrs.ngSrc);
               attrs.$set('ngSrc', fixedUrl);

            }
         });
         scope.$watch('src', () => {
            if (attrs.src) {
               var fixedUrl = this.fixUrl(attrs.src);
               attrs.$set('src', fixedUrl);
            }
         });
      }

      private fixUrl(url: string): string {
         const fixedUrl = url.replace('resources/', h5.resourcesDirectory + "/");
         return fixedUrl;
      }

      static MetaStructure: ng.IDirectiveFactory = {
         factory: [() => new ImageDirective()]
      };
   }

   angular.module("com.vmware.platform.ui").directive('img', ImageDirective.MetaStructure.factory);
}

